var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title-style"},[_vm._v("Reviews")]),_c('List',{staticClass:"my-5",attrs:{"reviews":_vm.reviews}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }